// extracted by mini-css-extract-plugin
export var megaMenu = "mega-menu-module--megaMenu--15bd1";
export var megaMenuHover = "mega-menu-module--megaMenuHover--06ccb";
export var navButton = "mega-menu-module--navButton--b0aaa";